const HEADER_OFFSET = 80

export function scrollToFirstSection(ids: string[], headerOffset = HEADER_OFFSET): void {
    const el = ids.map((id) => document.getElementById(id)).find(Boolean)
    const rect = el?.getBoundingClientRect()
    if (!rect) return

    const top = rect.top + window.pageYOffset - headerOffset

    window.scrollTo({top, behavior: "smooth"})
}
